var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartSquareBarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 8.66731V17.334M12.9997 11.9173V17.334M8.66634 15.1673V17.334M6.49967 21.6673H19.4997C20.0743 21.6673 20.6254 21.4391 21.0317 21.0327C21.4381 20.6264 21.6663 20.0753 21.6663 19.5007V6.50064C21.6663 5.92601 21.4381 5.37491 21.0317 4.96858C20.6254 4.56225 20.0743 4.33398 19.4997 4.33398H6.49967C5.92504 4.33398 5.37394 4.56225 4.96761 4.96858C4.56128 5.37491 4.33301 5.92601 4.33301 6.50064V19.5007C4.33301 20.0753 4.56128 20.6264 4.96761 21.0327C5.37394 21.4391 5.92504 21.6673 6.49967 21.6673Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSquareBarWhite);
export default __webpack_public_path__ + "static/media/chart-square-bar_white.12360167d24afbd01674fb8615526d2d.svg";
export { ForwardRef as ReactComponent };